import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
  margin-bottom: 1rem;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  border: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.5rem;
  outline: none;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  transition: all 0.2s;

  &:focus {
    border-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
    box-shadow: 0 0 0 2px ${(props) => (props.theme.colors?.primary || '#3b82f6')}20;
  }
`;

export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 20rem;
  overflow-y: auto;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
`;

export const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const UserItem = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${(props) =>
    props.$isSelected ? (props.theme.colors?.primary || '#3b82f6') + '20' : 'transparent'};

  &:hover {
    background-color: ${(props) =>
      props.$isSelected
        ? (props.theme.colors?.primary || '#3b82f6') + '30'
        : props.theme.colors?.gray01 || '#f5f5f5'};
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  margin-right: 0.75rem;
`;

export const Avatar = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const OnlineBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.75rem;
  height: 0.75rem;
  background-color: ${(props) => props.theme.colors?.success};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors?.white01 || '#ffffff'};
`;

export const OfflineBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.75rem;
  height: 0.75rem;
  background-color: ${(props) => props.theme.colors?.danger};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors?.white01 || '#ffffff'};
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.h3`
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  margin-bottom: 0.25rem;
`;

export const UserStatus = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
`;

export const Checkbox = styled.div<{ $isSelected: boolean }>`
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid
    ${(props) =>
      props.$isSelected
        ? props.theme.colors?.primary || '#3b82f6'
        : props.theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.25rem;
  background-color: ${(props) =>
    props.$isSelected ? props.theme.colors?.primary || '#3b82f6' : 'transparent'};
  color: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: bold;
`;

export const SelectedUsers = styled.div`
  margin-bottom: 1rem;
`;

export const SelectedUsersLabel = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
  margin-bottom: 0.5rem;
`;

export const SelectedUsersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const SelectedUserTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  background-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
  color: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  border-radius: 0.5rem;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const SelectedUserName = styled.span`
  font-weight: 500;
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  cursor: pointer;
  padding: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
`;

export const CancelButton = styled.button`
  flex: 1;
  padding: 0.75rem;
  background-color: ${(props) => props.theme.colors?.gray01 || '#f5f5f5'};
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  }
`;

export const AddButton = styled.button<{ disabled?: boolean }>`
  flex: 1;
  padding: 0.75rem;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors?.gray02 || '#e5e7eb'
      : props.theme.colors?.primary || '#3b82f6'};
  color: ${(props) =>
    props.disabled
      ? props.theme.colors?.text?.secondary || '#6b7280'
      : props.theme.colors?.white01 || '#ffffff'};
  border: none;
  border-radius: 0.5rem;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? props.theme.colors?.gray02 || '#e5e7eb'
        : props.theme.colors?.primary || '#2563eb'};
  }
`;

